import * as React from "react";
import type { SVGProps } from "react";
const SvgCloud01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.743 18.857a6.857 6.857 0 1 0 0-13.714 6.86 6.86 0 0 0-6.351 4.263 4.8 4.8 0 1 0-1.192 9.45z"
    />
  </svg>
);
export default SvgCloud01;
